import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function TermsOfService() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow bg-white">
        {/* Hero Section */}
        <section className="bg-stone-50 py-8">
          <div className="container mx-auto px-6">
            <h1 className="text-2xl font-bold text-gray-800 mb-2">Terms of Service</h1>
            <p className="text-sm text-gray-600">Last updated: {new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
          </div>
        </section>

        {/* Content Section */}
        <section className="py-8">
          <div className="container mx-auto px-6 max-w-4xl">
            <div className="prose prose-lg max-w-none">
              
              {/* Introduction */}
              <div className="mb-6">
                <p className="text-gray-600 leading-relaxed text-xs">
                  Welcome to Vine Consulting Engineers' website ("we", "our", or "us"). By accessing or using this website, you agree to these Terms of Service. Please read them carefully before using the site.
                </p>
              </div>

              {/* Use of the Website */}
              <div className="mb-6">
                <h2 className="text-lg font-bold text-gray-800 mb-2">1. Use of the Website</h2>
                <p className="text-gray-600 leading-relaxed mb-2 text-xs">
                  This website is provided for general information about our civil engineering consultancy services. You must use it lawfully and not for any purpose that may damage, disable, or impair its operation or our reputation.
                </p>
                <p className="text-gray-600 leading-relaxed text-xs">
                  We reserve the right to modify or withdraw the website, or restrict access, at any time without notice.
                </p>
              </div>

              {/* Intellectual Property */}
              <div className="mb-6">
                <h2 className="text-lg font-bold text-gray-800 mb-2">2. Intellectual Property</h2>
                <p className="text-gray-600 leading-relaxed text-xs">
                  All content on this website, including text, graphics, logos, and designs, is owned by or licensed to Vine Consulting Engineers and protected by copyright and other intellectual property laws. You may view and print material for personal reference only. No material may be reproduced, distributed, or used commercially without prior written consent.
                </p>
              </div>

              {/* Disclaimer */}
              <div className="mb-6">
                <h2 className="text-lg font-bold text-gray-800 mb-2">3. Disclaimer</h2>
                <p className="text-gray-600 leading-relaxed text-xs">
                  Information on this website is provided in good faith for general guidance only. It does not constitute professional or technical advice. While efforts are made to ensure accuracy, we make no warranties or representations about completeness or reliability. Users should seek appropriate professional advice before relying on any information.
                </p>
              </div>

              {/* Limitation of Liability */}
              <div className="mb-6">
                <h2 className="text-lg font-bold text-gray-800 mb-2">4. Limitation of Liability</h2>
                <p className="text-gray-600 leading-relaxed text-xs">
                  To the fullest extent permitted by law, Vine Consulting Engineers accepts no liability for any loss, damage, or expense arising from the use of, or inability to use, this website or its content.
                </p>
              </div>

              {/* External Links */}
              <div className="mb-6">
                <h2 className="text-lg font-bold text-gray-800 mb-2">5. External Links</h2>
                <p className="text-gray-600 leading-relaxed text-xs">
                  This website may include links to other websites. We have no control over the content of those sites and accept no responsibility for them or any loss that may result from their use.
                </p>
              </div>

              {/* Governing Law */}
              <div className="mb-6">
                <h2 className="text-lg font-bold text-gray-800 mb-2">6. Governing Law</h2>
                <p className="text-gray-600 leading-relaxed text-xs">
                  These Terms are governed by the laws of England and Wales. Any disputes arising in connection with these Terms shall be subject to the exclusive jurisdiction of the courts of England and Wales.
                </p>
              </div>

              {/* Contact */}
              <div className="mb-6">
                <h2 className="text-lg font-bold text-gray-800 mb-2">7. Contact</h2>
                <p className="text-gray-600 leading-relaxed mb-2 text-xs">
                  If you have any questions about these Terms, please contact us at:
                </p>
                <div className="bg-emerald-50 p-4 rounded-lg border border-emerald-200">
                  <p className="text-gray-700 mb-1 text-xs"><strong>Vine Consulting Engineers</strong></p>
                  <p className="text-gray-600 mb-1 text-xs">
                    <i className="ri-mail-line text-emerald-600 mr-2"></i>
                    Email: Mail@VineCE.co.uk
                  </p>
                  <p className="text-gray-600 mb-1 text-xs">
                    <i className="ri-phone-line text-emerald-600 mr-2"></i>
                    Phone: +44(0) 7774 218 135
                  </p>
                  <p className="text-gray-600 text-xs">
                    <i className="ri-map-pin-line text-emerald-600 mr-2"></i>
                    Address: Alton, Hampshire, GU34 2UW
                  </p>
                </div>
              </div>

            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}